document.addEventListener('DOMContentLoaded', function () {
    const stickyMenu = document.querySelector('.pc-sticky-menu')
    const masthead = document.querySelector('#masthead')

    if (!stickyMenu || !masthead) return

    const updateStickyMenu = () => {
        const mastheadHeight = masthead.offsetHeight
        if (stickyMenu.style.top !== `${mastheadHeight}px`) {
            stickyMenu.style.top = `${mastheadHeight}px`
        }
    }

    updateStickyMenu()

    let resizeTimeout
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(updateStickyMenu, 100)
    })
})
